export { Icon } from './icon'
export type { IconNames } from './icon.types'
